import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserStore } from '../store/userStore';

const Logout = () => {
  const { logout } = useUserStore();

  useEffect(() => {
    // 로그아웃 처리
    logout();
    
    // 로컬 스토리지 클리어
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
  }, [logout]);

  // 로그인 페이지로 리다이렉트
  return <Navigate to="/" replace />;
};

export default Logout;